<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'item'],
		data () {
			return {
				modal: {
					selector: 'modal-create'
				},
				types: [
					'Imprevisto',
					'Baja',
					'Vacaciones',
				],
				data: {
					staff_id: null,
					start_date: null,
					end_date: null,
					comment: null,
					type: 'Imprevisto',
				}
			}
		},
		watch: {
			'data.start_date': function() {
				if(this.data.start_date) {
					this.checkUserHasSchedules()
				}
			},
			'data.end_date': function() {
				if(this.data.end_date) {
					this.checkUserHasSchedules()
				}
			},
		},
		computed: {
			isSame: function () {
				var start = moment(this.data.start_date)
				var end = moment(this.data.end_date)

				if(start.isValid() && end.isValid()) {
					return start.isSame(end)
				}
			},
		},
		methods: {
			init() {

			},
			open() {
				this.clearData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
				this.clearData()
				this.checkUserHasSchedules()
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.data.staff_id = null
				this.data.start = null
				this.data.date = null
				this.data.comment = null
				this.data.type = 'Imprevisto'
			},
			store() {
				this.formatData()
				if(this.validDates()) {
					var loading = Ladda.create(this.$refs.btnStore)
					loading.start()

					this.data.profile_id = this.item.profile.id

					this.$http.post('admin/unavailable', this.data)
					.then(response => {
						loading.stop()
						this.$emit('reload')
						this.close()
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}).catch(function(response) {
						loading.stop()
						this.$emit('reload')
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning",
						})
					})
				} else {
					var that = this
					swal({
						title: 'Error',
						text: this.$t("messages.the_dates_are_incorrect"),
						type: "warning",
					})
				}
			},
			validDates() {
				var start = moment(this.data.start_date)
				var end = moment(this.data.end_date)

				if(start.isValid() && end.isValid()) {
					return true
				} else {
					return false
				}
			},
			checkUserHasSchedules() {
				if(typeof this.item.display_alert == 'undefined') {
					var start_date = this.data.start_date
					var end_date = this.data.end_date

					var tasks = this.item.tasks
					if(tasks) {
						for (var i = 0; i < tasks.length; i++) {
							var task = tasks[i]
							var schedules = task.schedules
							if(schedules.length) {
								for (var k = 0; k < schedules.length; k++) {
									var element = schedules[k]

									var start = moment(element.estimated_start)
									var end = moment(element.estimated_end)

									var start_date = moment(start_date)
									var end_date = moment(end_date)

									var betweenStart = start.isBetween(start_date, end_date)
									var isSameStart = start.isSame(start_date)
									var betweenEnd = end.isBetween(start_date, end_date)
									var isSameEnd = end.isSame(end_date)

									if(betweenStart || betweenEnd || isSameStart || isSameEnd) {
										swal({
											title: this.$t("messages.attention"),
											text: this.$t("messages.staff_has_tasks_on_dates"),
											type: 'warning',
											showCloseButton: true,
											showCancelButton: true,
											confirmButtonText: 'Ignorar',
											confirmButtonColor: "#ff7676",
											cancelButtonColor: '#3085d6',
											cancelButtonText: 'OK',
										})
										.then((result) => {
											this.item.display_alert = false
										})
									} else {
										var betweenStart = start_date.isBetween(start, end)
										var betweenEnd = end_date.isBetween(start, end)

										if(betweenStart || betweenEnd) {
											swal({
												title: this.$t("messages.attention"),
												text: this.$t("messages.staff_has_tasks_on_dates"),
												type: 'warning',
												showCloseButton: true,
												showCancelButton: true,
												confirmButtonText: 'Ignorar',
												confirmButtonColor: "#ff7676",
												cancelButtonColor: '#3085d6',
												cancelButtonText: 'OK',
											})
											.then((result) => {
												this.item.display_alert = false
											})
										}
									}
								}
							}
						}
					}
				}
			},
			formatData() {
				if(this.data.start_date) {
					var start_date = moment(this.data.start_date)
					this.data.start_date = start_date.format('YYYY-MM-DD H:mm:ss')
				}
				if(this.data.end_date) {
					var end_date = moment(this.data.end_date)
					this.data.end_date = end_date.format('YYYY-MM-DD H:mm:ss')
				}
			},
		}
	}
</script>

<style>
	#textarea-comment {
		padding: 5px;
		font-size: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/components/projects/availability/views/Create.vue